module.exports = __webpack_public_path__ + "static/media/user-checklist-background-side.58c1b086.png";